<!-- LONG TERM TODO: In case most of the stuff will remain the same between the register and social-login-register
 pages, then the duplicated code should be refactored  -->
<div class="container mt-4">
  <div class="row mb-3">
    <div class="col-12">
      <h1 class="text-center">
        Your details
      </h1>
    </div>
  </div>

  <div class="row mb-5">
    <div class="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4 mb-3">
      <form
       #registerForm="ngForm"
       (ngSubmit)="finalizeSocialUserData()"
       novalidate>

        <form
         #emailSubform="ngForm"
         [appMatchingFields]="['email', 'emailConfirm']"
         novalidate>
          <div class="mb-3">
            <label class="form-label" for="email">
              Email address
            </label>
            <input
              #email="ngModel"
              class="form-control"
              [class.is-invalid]="email.touched && !email.valid"
              [emailDot]="true"
              id="email"
              name="email"
              [(ngModel)]="model.emailAddress"
              placeholder="Email address"
              required
              type="email"/>
            <div
              *ngIf="email.errors && email.errors.required"
              class="invalid-feedback">
              {{ errorStrings.required }}
            </div>
            <div
              *ngIf="email.errors && email.errors.email"
              class="invalid-feedback">
              {{ errorStrings.emailInvalid }}
            </div>
            <div
              *ngIf="email.errors && email.errors.emailMustEndWith"
              class="invalid-feedback">
              {{ errorStrings.emailMustEndWith }}
            </div>
          </div>
        </form>

        <form
          #communicationSubform="ngForm"
          novalidate>

          <div class="mb-3 text-center">
            <div class="justify-text">
              By creating and account you agree to identibase’s
              <a routerLink="/terms-and-conditions" target="_blank">
                terms & conditions
              </a>
              and
              <a routerLink="/privacy" target="_blank">
                privacy policy.
              </a>
            </div>
          </div>

          <span [formGroup]="communicationForm">
            <div class="mb-3">
              <label class="form-check-label d-flex justify-content-center align-items-center">
                <input
                 class="form-control me-3 communication-checkbox internal-communication-checkbox"
                 id="subToAllInternalCommunication"
                 name="subToAllInternalCommunication"
                 formControlName="subscribeToAllInternalCommunication"
                 type="checkbox">
                  <div class="justify-text">
                    We would love to keep you up to date with all our latest news,
                    offers, useful pet tips and pet related content. Tick the box
                    if you <strong>do not want</strong> to be contacted.
                  </div>
              </label>
            </div>

            <div class="justify-text">
              <p>
                We have partnered with carefully selected 3rd parties so that
                we can send you exclusive offers and promotions on pet food,
                pet accessories, pet insurance and other pet related services
                by email and SMS.
              </p>
            </div>

            <div formGroupName="thirdPartySubscribeOptionSelectGroup">
              <div class="mb-3">
                <label class="form-check-label d-flex align-items-center">
                  <input
                   class="form-control me-3 communication-checkbox"
                   id="subscribeToAllThirdParty"
                   name="subscribeToAllThirdParty"
                   formControlName="subscribeToAllThirdParty"
                   (change)="onSubscribeOptionChanged($event)"
                   type="checkbox">
                    <span>Tick here if you <strong>do want</strong> to receive this or</span>
                </label>
              </div>

              <div class="mb-3">
                <label class="form-check-label d-flex align-items-center">
                  <input
                    class="form-control me-3 communication-checkbox"
                    id="unsubscribeFromAllThirdParty"
                    name="unsubscribeFromAllThirdParty"
                    formControlName="unsubscribeFromAllThirdParty"
                    (change)="onSubscribeOptionChanged($event)"
                    type="checkbox">
                    <span>Tick here if you <strong>do not want</strong> to receive this.</span>
                </label>
              </div>

              <span *ngIf="thirdPartyCheckboxStateChanged && communicationForm.controls['thirdPartySubscribeOptionSelectGroup'].errors" class="invalid-checkboxes">
                One of the two options is required
              </span>

              <div class="justify-text mt-2">
                <p>
                  We do not pass on your personal data to any 3rd parties.
                </p>
              </div>
            </div>
          </span>
        </form>

        <button
          type="submit"
          class="btn btn-success text-white btn-lg w-100 mt-2"
          [disabled]="!registerForm.valid || !emailSubform.valid || !communicationSubform.valid ||
           loading || communicationForm.invalid">
            <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
            {{ loading ? 'Finalize...' : 'Finalize' }}
        </button>

        <div class="mb-3 mt-5">
          <label class="justify-text form-label">
            You can change your communication options or unsubscribe at any time by
            updating your account preferences in your account or by contacting us.
          </label>
        </div>
      </form>
    </div>
  </div>

</div>
